import { authFetch } from '../AuthFetch';

//id :case pk
export const forwardToFindRefinableMCards = (cardRequest) => (
  (dispatch) => {
    let id = cardRequest.casePk;
    let url = '/maintenance/mcases/i'+id+'/cards/status';
    authFetch('POST', url, JSON.stringify(cardRequest), (json) => {
      dispatch({
        type: 'FIND_REFINABLE_M_CARDS',
        payload: json
      });
    });
  }
);

export const forwardToRefineMaintenanceCard = (cardPk, casePk, operator) => (
  (dispatch) => {
    let id = cardPk;
    let cardRequest = {
        casePk: casePk, 
        cardId: cardPk, 
        operator:operator,
        cardStatuss:["REFINED","COMPLETED","MODIFIED","AUDITED"]
      }
    let url = '/maintenance/cards/i'+id+'/refined';
    authFetch('POST', url, JSON.stringify(cardRequest), (json) => {
      dispatch({
        type: 'FIND_REFINABLE_M_CARDS',
        payload: json
      });
      dispatch({
        type: 'SHOW_GLOBAL_ALERT',
        payload: json.displayMessage
      });
    });
  }
);



// WEBPACK FOOTER //
// ./src/actions/maintenanceRefineCardsAction.js